import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import Form from "./Form";
import { useMemo } from "react";

const Checkout = (props) => {
  const stripePromise = useMemo(
    () => loadStripe(props.stripePublishableKey),
    [props.stripePublishableKey]
  );

  const options = {
    clientSecret: props.clientSecret,
    appearance: { theme: "stripe" },
  };

  return (
    <Elements options={options} stripe={stripePromise}>
      <Form cost={props.costInPounds} clientSecret={props.clientSecret} draftOrderId={props.draftOrderId} termsHref={props.termsHref} />
    </Elements>
  );
};

export default Checkout;
